import permissions from '@/constants/permissions'

const PaymentsList = () => import('@/views/dashboard/PaymentsList.vue')

export default {
  path: '/lista-wplat',
  name: 'PaymentsList',
  component: PaymentsList,
  meta: {
    requireAuth: true,
    permission: permissions.paymentAccess
  }
}
